import React, { PureComponent } from 'react'
import FieldRowWrapper from '../FieldRowWrapper/FieldRowWrapper'
import vMasker from 'vanilla-masker'
import Calender from './Calender'
import clsx from 'clsx'
import ClickOutside from 'react-clickoutside-component'
import moment from 'moment-jalaali'
import { injectIntl } from 'react-intl'
import {
  ensureEnglishNumber,
  toPersianDigit,
  replaceLastInstance,
} from '../../../helpers/generalHelpers'

import './date-input.css'
import './calender.css'
import settings from '../../../settings'
import RawHtml from 'stories/components/RawHtml'

const { locales } = settings
// adapters between calender and this component
// and between this component and it's parent
const calenderToInputRegex = new RegExp('/', 'g')

const toGregorianDate = (dateString) => {
  if (!dateString) return undefined
  const date = moment(dateString, 'jYYYY-jMM-jDD')
  if (date && date.isValid()) {
    return date.format('YYYY-MM-DD')
  } else {
    return undefined
  }
}

const toJalaaliDate = (dateString) => {
  if (!dateString) return undefined
  const date = moment(dateString)
  if (date && date.isValid()) {
    return date.format('jYYYY-jMM-jDD')
  } else {
    return undefined
  }
}

class CustomizedDateInput extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hasFocus: false,
      maskedValue: '',
      isDatePickerActive: false,
    }
  }

  formatUserInput = (value) => {
    const { maskedValue } = this.state
    // check if user is removing the input and it has 2 of 3 parts ($1)/($2)/($3)
    if (
      /^(\d{4})(\/)(\d{2})(\/)(\d{1})$/.test(maskedValue) &&
      /^(\d{4})(\/)(\d{2})$/.test(value)
    ) {
      return this.maskDate(replaceLastInstance(value, '/', ''))
    } else if (
      // check if user is removing the input and it has 2 of 3 parts and there is no numbers in part 3
      /^(\d{4})(\/)(\d{2})(\/)$/.test(maskedValue) &&
      /^(\d{4})(\/)(\d{2})$/.test(value)
    ) {
      return this.maskDate(replaceLastInstance(value, '/', ''))
    } else if (
      // check if user is removing the input and it has 1 of 3 parts
      /^(\d{4})(\/)(\d{1})$/.test(maskedValue) &&
      /^(\d{4})$/.test(value)
    ) {
      return this.maskDate(replaceLastInstance(value, '/', ''))
      // check if user is typing and has written 1 of 3 parts
    } else if (/^\d{4}$/.test(value)) {
      return value + '/'
      // check if user is typing and has written 2 of 3 parts
    } else if (/^(\d{4})(\/)(\d{2})$/.test(value)) {
      return value + '/'
    }
    // if not, return the value
    return value
  }

  maskDate = (rawValue) => vMasker.toPattern(rawValue, '9999/99/99')

  unMaskDate = (rawValue) => rawValue.replace(calenderToInputRegex, '-')

  onInputChange = (event) => {
    this.updateValue({
      value: event.target.value,
      shouldUpdateParent: true,
    })
  }

  updateValue = ({ value, shouldUpdateParent }) => {
    const maskedValue = this.formatUserInput(
      this.maskDate(ensureEnglishNumber(value))
    )

    this.setState(
      {
        maskedValue,
        isDatePickerActive: false,
      },
      () => {
        if (shouldUpdateParent) {
          const outputValue = this.applyMasking()
            ? toGregorianDate(this.unMaskDate(maskedValue))
            : this.unMaskDate(maskedValue)

          this.props.onChange(outputValue || null)
        }
      }
    )
  }

  componentDidMount = () => {
    // makes this component hybrid, if there is a value prop
    // it will respect it but otherwise it is independent 🍺👍
    const { value } = this.props

    if (value) {
      this.updateValue({
        value: this.applyMasking() ? toJalaaliDate(value) : value,
        shouldUpdateParent: false,
      })
    }
  }

  onInputFocus = () => {
    this.setState(
      {
        hasFocus: true,
        isDatePickerActive: true,
      },
      () => {
        this.props.onFocus && this.props.onFocus()
      }
    )
  }

  onInputBlur = () => {
    this.setState({ hasFocus: false }, () => {
      this.props.onBlur && this.props.onBlur()
    })
  }

  getInputValue = () =>
    this.props.value
      ? this.applyMasking()
        ? toPersianDigit(this.state.maskedValue)
        : this.props.value
      : ''

  onCalenderInput = (value) => {
    // returns a jalaali value
    this.updateValue({
      value,
      shouldUpdateParent: true,
    })
  }

  requestCalenderClose = () => {
    this.setState({ isDatePickerActive: false })
  }

  gregToJalaaliParser = (dateString) => {
    const date = moment(dateString)
    if (date.isValid()) {
      return toPersianDigit(date.format('jDD-jMM-jYYYY'))
    } else {
      return ''
    }
  }

  isDateValid = (dateString) => moment(dateString).isValid()

  generateDescription = (desc = '', min, max) => {
    if (!this.applyMasking()) return desc

    if (max && min) {
      if (this.isDateValid(min) && this.isDateValid(max)) {
        return `${(
          <RawHtml content={desc} />
        )} (تاریخی بین ${this.gregToJalaaliParser(
          min
        )} و ${this.gregToJalaaliParser(max)})`
      }
    }

    if (min) {
      if (this.isDateValid(min)) {
        return `${(
          <RawHtml content={desc} />
        )} (تاریخی بعد از ${this.gregToJalaaliParser(min)})`
      }
    }

    if (max) {
      if (this.isDateValid(max)) {
        return `${(
          <RawHtml content={desc} />
        )} (تاریخی قبل از ${this.gregToJalaaliParser(max)})`
      }
    }

    return desc
  }

  applyMasking = () => {
    const {
      intl: { locale = locales.fa },
    } = this.props
    if (locale === locales.fa) return true

    return false
  }

  getFromIntl = () =>
    this.props.intl.formatMessage({ id: 'form.fields.date.placeholder' })

  render() {
    const {
      label = '',
      name = '',
      placeholder,
      required,
      touched,
      error,
      description,
      from_date,
      to_date,
      date_format,
    } = this.props

    const classNames = {
      'formz-date-input': true,
      'formz-has-focus': this.state.hasFocus,
      'formz-has-error': this.props.error,
      'full-width': this.props.fullWidth,
    }

    return (
      <FieldRowWrapper
        className={classNames}
        error={error}
        touched={touched ? touched.toString() : undefined}
      >
        <ClickOutside onClickOutside={this.requestCalenderClose}>
          <label className="formz-field-and-label-holder">
            <div className="formz-input-title">
              {label} {required && '(*)'}
            </div>

            <div className="formz-field-description">
              {this.generateDescription(description, from_date, to_date)}
            </div>

            <input
              type="text"
              name={name}
              value={this.getInputValue()}
              className="formz-input-field ltr-on-type"
              placeholder={date_format || placeholder || this.getFromIntl()}
              onChange={this.onInputChange}
              onFocus={this.onInputFocus}
              onBlur={this.onInputBlur}
            />

            {this.applyMasking() && (
              <div
                className={clsx({
                  calender: true,
                  active: this.state.isDatePickerActive,
                })}
              >
                <Calender onChange={this.onCalenderInput} />
              </div>
            )}
          </label>
        </ClickOutside>
      </FieldRowWrapper>
    )
  }
}

export default injectIntl(CustomizedDateInput)
